import { formatDistanceToNow } from "date-fns";

export interface RecentAnalysisRow {
  id: string;
  lookbook_image_url: string | null;
  thumbnail_url: string | null;
  image_url: string | null;
  hero_item_name: string | null;
  title: string | null;
  occasion: string | null;
  hero_item_category: string | null;
  created_at: string;
  lookbook_status: string | null;
  // LB4-RECENTS-SAVED-ROUTING — detect wardrobe_combinator rows at tap
  // time and route them to StyleYourselfResult instead of viewOutfit.
  input_method?: string | null;
}

interface RecentAnalysesListProps {
  analyses: RecentAnalysisRow[];
  onAnalysisTap: (id: string) => void;
}

const INK = "#2C2820";
const DIM = "#9B958E";
const BORDER = "#F1EFE8";

export default function RecentAnalysesList({
  analyses,
  onAnalysisTap,
}: RecentAnalysesListProps) {
  if (analyses.length === 0) return null;
  const rows = analyses.slice(0, 5);

  return (
    <div>
      <div
        className="l2f-type-section-header"
        style={{
          color: DIM,
          padding: "16px 16px 8px",
        }}
      >
        RECENT
      </div>
      {rows.map((r, i) => {
        const isLast = i === rows.length - 1;
        // GUEST-RECENTS-TAP-COSMETIC-1: filter out "signed://" sentinel
        // values written by screenshot insert paths; they are not loadable
        // URLs and would render as a broken-image glyph. Loader icon
        // fallback at L91-95 fires when this resolves to null.
        const isValidUrl = (u: string | null | undefined) =>
          u != null && u.length > 0 && !u.startsWith("signed://");
        const thumb =
          r.lookbook_status === "ready" && isValidUrl(r.lookbook_image_url)
            ? r.lookbook_image_url
            : isValidUrl(r.thumbnail_url)
              ? r.thumbnail_url
              : isValidUrl(r.image_url)
                ? r.image_url
                : null;
        const name = r.hero_item_name || r.title || "Look";
        const occ = r.occasion || r.hero_item_category || "Look";
        const ago = formatDistanceToNow(new Date(r.created_at), {
          addSuffix: true,
        });
        return (
          <button
            key={r.id}
            type="button"
            onClick={() => onAnalysisTap(r.id)}
            aria-label={`${name}, ${occ}, ${ago}`}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "12px 16px",
              height: 56,
              background: "transparent",
              border: "none",
              borderBottom: isLast ? "none" : `0.5px solid ${BORDER}`,
              cursor: "pointer",
              textAlign: "left",
            }}
          >
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 8,
                background: "#EDE8E2",
                overflow: "hidden",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {thumb ? (
                <img
                  src={thumb}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <i
                  className="ti ti-loader-2"
                  aria-hidden="true"
                  style={{ fontSize: 16, color: DIM }}
                />
              )}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: INK,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {name}
              </div>
              <div className="l2f-type-caption" style={{ color: DIM }}>
                {occ} · {ago}
              </div>
            </div>
            <i
              className="ti ti-chevron-right"
              style={{ fontSize: 16, color: DIM }}
              aria-hidden="true"
            />
          </button>
        );
      })}
    </div>
  );
}
